import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

export default function PengumumanAgendaDetail() {
  const { id } = useParams();
  const [item, setItem] = useState(null);

  useEffect(() => {
    const fetchDetail = async () => {
      const docRef = doc(db, "pengumumanAgenda", id);
      const snap = await getDoc(docRef);
      if (snap.exists()) setItem(snap.data());
    };
    fetchDetail();
  }, [id]);

  if (!item) return <p className="text-center mt-5">Memuat data...</p>;

  return (
    <div className="container mt-5 mb-5">
      {/* Tombol Kembali ke Beranda */}
      <Link to="/" className="btn btn-primary mb-4">
        ← Kembali ke Beranda
      </Link>

      {/* Card Detail */}
      <div className="card shadow p-4 fade-in-up">
        <h2 className="fw-bold mb-2">{item.judul}</h2>
        <p className="text-muted mb-3">{new Date(item.tanggal).toLocaleDateString()}</p>

        {item.type === "pengumuman" && (
          <div className="mb-3">
            <p>{item.deskripsi}</p>
          </div>
        )}

        {item.type === "agenda" && (
          <div className="mb-3">
            {item.lokasi && <p><strong>Lokasi:</strong> {item.lokasi}</p>}
            {item.deskripsi && <p>{item.deskripsi}</p>}
          </div>
        )}
      </div>
    </div>
  );
}
